export default function HeroTextData() {
  return [
    {
        title: "Disability Insurance",
        subtitle: "Instant: Click. Quote. Coverage.",
        subtitleExtended: "See your options immediately and apply in minutes"
    },
    {
        title: "Disability Insurance",
        subtitle: "Easy: Simple online experience",
        subtitleExtended: "Step by step application with helpful hints along the way"
    },
    {
        title: "Disability Insurance",
        subtitle: "Personal: Disability insurance that's right for you",
        subtitleExtended: "Easily determine the right amount of coverage that fits our budget"
    },
    {
        title: "Disability Insurance",
        subtitle: "Purchasing Options: In-person help is always available",
        subtitleExtended: "Get assistance via phone from licensed specialists in all 50 states"
    }
  ]
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/LongTermDisability/HeroTextData.js